
<app-additionals-notes [subModule]="subModule"></app-additionals-notes>